import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { PublicLayout } from "@/components/PublicLayout";
import { PricingCard } from "@/components/PricingCard";
import { ShieldCheck, RefreshCcw, Headphones } from "lucide-react";

export default function Packages() {
  const { data: packages = [], isLoading } = useQuery({ queryKey: ["packages"], queryFn: async () => (await api.get("/packages")).data });

  return (
    <PublicLayout>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-10 text-center">
        <p className="text-xs font-semibold uppercase tracking-widest text-purple-400 mb-3">Pricing Plans</p>
        <h1 className="font-heading text-4xl sm:text-5xl font-extrabold text-white">Pick the perfect package</h1>
        <p className="text-slate-400 mt-4 max-w-2xl mx-auto">All plans include full channel access, 4K quality and 24/7 support. Upgrade or renew anytime.</p>
      </section>
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-12">
        {isLoading ? (
          <div className="text-center text-slate-400 py-20">Loading packages…</div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {packages.map((p) => <PricingCard key={p.id} pkg={p} />)}
          </div>
        )}
      </section>
      <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pb-20 grid sm:grid-cols-3 gap-6">
        {[
          { icon: ShieldCheck, t: "Secure Checkout", d: "Your order is reviewed and activated by our team." },
          { icon: RefreshCcw, t: "Easy Renewal", d: "Extend your plan anytime from your dashboard." },
          { icon: Headphones, t: "24/7 Support", d: "We're one WhatsApp message away, day or night." },
        ].map((x) => (
          <div key={x.t} className="glass rounded-2xl p-6 text-center">
            <x.icon className="w-8 h-8 text-neon-purple mx-auto mb-3" />
            <h3 className="font-heading font-semibold text-white mb-1">{x.t}</h3>
            <p className="text-sm text-slate-400">{x.d}</p>
          </div>
        ))}
      </section>
    </PublicLayout>
  );
}
